/* Header Fusão: menu inteiro à esquerda, logo no centro, ícones à direita.
   O tema entrega o menu partido em dois (metade antes e metade depois do logo);
   aqui as duas metades viram uma só e a busca vai para o grupo de ícones. */
(() => {
  const arrange = () => {
    document.querySelectorAll('.row-header').forEach((row) => {
      if (row.dataset.nfHeader === 'done') return;
      const left = row.querySelector('.menudesk-left');
      const right = row.querySelector('.menudesk-right');
      if (!left || !right) return;

      const leftList = left.querySelector('nav.nav-bar ul.site-nav');
      const rightList = right.querySelector('nav.nav-bar ul.site-nav');
      if (leftList && rightList) {
        while (rightList.firstElementChild) leftList.appendChild(rightList.firstElementChild);
        const emptyNav = rightList.closest('nav.nav-bar');
        if (emptyNav) emptyNav.remove();
      }

      const search = left.querySelector('.col_bottom__left');
      const icons = right.querySelector('.header-bottom__right');
      if (search && icons) icons.insertBefore(search, icons.firstChild);

      row.dataset.nfHeader = 'done';
      row.classList.add('nf-header-ready');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrange);
  } else {
    arrange();
  }
  window.setTimeout(arrange, 600);
  window.setTimeout(arrange, 1800);
})();
